module.exports = __webpack_public_path__ + "img/USD.af28f526.svg";